import { render, staticRenderFns } from "./LeakCreatePage.vue?vue&type=template&id=2b8a8258&scoped=true"
import script from "./LeakCreatePage.vue?vue&type=script&lang=ts"
export * from "./LeakCreatePage.vue?vue&type=script&lang=ts"
import style0 from "./LeakCreatePage.vue?vue&type=style&index=0&id=2b8a8258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8a8258",
  null
  
)

export default component.exports